import { setContext } from '@apollo/client/link/context'
import { Auth } from 'aws-amplify'
import Swal, { SweetAlertIcon } from 'sweetalert2'
import { CHECK_UPLOAD_STATUS_FETCH } from './GraphQLAPI'
import { SERVER_URL } from './config'
import withReactContent from 'sweetalert2-react-content'
import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import SwalThinkingImage from '../_metronic/images/swal_thinking_face.svg'
import fileDownload from 'js-file-download'
import { GLOBAL_CONSTANTS } from './GlobalConstants'
import imageCompression from 'browser-image-compression'
const inProgress = 'In Progress'
const MySwal = withReactContent(Swal)

export const getToken = async () => {
  return Auth.currentSession()
    .then((data: any) => {
      const refreshAccessToken = data.getAccessToken().getJwtToken()
      localStorage.setItem('_accesstoken', refreshAccessToken)
      return refreshAccessToken
    })
    .catch((err: any) => {
      console.log('Refresh token error here', err)
    })
}
export const getIDToken = async () => {
  return Auth.currentSession()
    .then((data: any) => {

      return data.getIdToken().getJwtToken()
    })
    .catch((err: any) => {
      console.log('Refresh token error here', err)
    })
}
export const setAuthorizationLink = setContext(async (request: any, previousContext: any) => {
  // if you have a cached value return immediately
  let _accessToken: any = localStorage.getItem('_accesstoken') || ''

  if (_accessToken) {
    const jwtPayload = JSON.parse(window.atob(_accessToken.split('.')[1]))
    const isExpired = Date.now() >= jwtPayload.exp * 1000

    if (isExpired) {
      _accessToken = await getToken()
    }
  }
})

export const adminRoles = {
  TPV_ADMIN: 'tpvadmin',
  SALES_ADMIN: 'salesadmin',
  CLIENT_ADMIN: 'clientadmin',
  AGENT_ADMIN: 'agent',
  SYSTEM_ADMIN: 'systemadmin',
  QC_USER: 'qcuser',
  LIVE_AGENT: 'liveagent',
}

export const navigateUser = (
  userRole: any,
  setHeader: any,
  setUserRole: any = () => { },
  setRoles: any = () => { }
) => {
  switch (userRole) {
    case adminRoles.TPV_ADMIN: {
      setHeader('T P V')
      setRoles('TPV_ADMIN')
      setUserRole(adminRoles.TPV_ADMIN)
      break
    }
    case adminRoles.CLIENT_ADMIN: {
      setHeader('C L I E N T')
      setRoles('CLIENT_ADMIN')
      setUserRole(adminRoles.CLIENT_ADMIN)

      break
    }
    case adminRoles.AGENT_ADMIN: {
      setHeader('A G E N T')
      setRoles('AGENT')
      setUserRole(adminRoles.AGENT_ADMIN)

      break
    }
    case adminRoles.SYSTEM_ADMIN: {
      setHeader('S Y S T E M')
      setRoles('SYSTEM_ADMIN')
      setUserRole(adminRoles.SYSTEM_ADMIN)

      break
    }
    case adminRoles.SALES_ADMIN: {
      setHeader('S A L E S')
      setRoles('SALES_ADMIN')
      setUserRole(adminRoles.SALES_ADMIN)

      break
    }
    case adminRoles.QC_USER: {
      setHeader('Q C')
      setRoles('QC_USER')
      setUserRole(adminRoles.QC_USER)

      break
    }
    case adminRoles.LIVE_AGENT: {
      setHeader('L I V E  A G E N T')
      setRoles('LIVE_AGENT')
      setUserRole(adminRoles.LIVE_AGENT)

      break
    }
    default:
      break
  }
}

export const restrictDecimal = (fee: any) => {
  return fee.indexOf('.') >= 0
    ? fee.substr(0, fee.indexOf('.')) + fee.substr(fee.indexOf('.'), 5)
    : fee
}

export const preventScroll = (e: any) => {
  e.target.addEventListener('wheel', (e: any) => e.preventDefault(), { passive: false })
}

export const toaster = (message: any, icon: any) => {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timerProgressBar: true,
    ...(message !== inProgress && { timer: 3000 }),
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
      message === inProgress && Swal.showLoading()
    },
  })
  Toast.fire({
    icon,
    title: message,
  })
}

export const alert = (title: string, icon: SweetAlertIcon) => {
  MySwal.fire({
    icon,
    title,
  })
}

export const showAlertWithCallbackOnConfirmation = (
  title: string,
  icon: SweetAlertIcon,
  callback?: () => void
) => {
  MySwal.fire({
    icon,
    title,
  }).then((result) => {
    if (result.isConfirmed && callback) {
      callback()
    }
  })
}

export const checkUploadStatus = async (trackId: any, refetchList: any, toasterReq = true) => {
  const tempHeader: any = {
    'Content-Type': GLOBAL_CONSTANTS.apiContentTypejson,
    Authorization: `Bearer ${localStorage.getItem('_accesstoken')}`,
  }
  const url = SERVER_URL || ''
  if (!trackId) {
    return;
  }
  const response = await fetch(url, {
    method: 'POST',
    headers: new Headers(tempHeader),
    body: JSON.stringify({
      query: CHECK_UPLOAD_STATUS_FETCH,
      variables: {
        trackId,
      },
    }),
  })
    .then((res) => {
      return res.json()
    })
    .catch((error) => {
      toaster(`${error.message}`, 'error')
    })
  const apiResponse = await response
  if (apiResponse.data.checkUploadStatus.response === 'In progress') {
    toasterReq && toaster(inProgress, 'info')
    setTimeout(() => {
      checkUploadStatus(trackId, refetchList, false)
    }, 3000)
    refetchList()
  } else {
    apiResponse.data?.checkUploadStatus.records?.forEach((result: any) => {
      if (result.up_status === 'failed') {
        toaster(
          `${result.count} of ${apiResponse.data.checkUploadStatus.total} has failed! Email has been sent to Admin`,
          'warning'
        )
      }
      refetchList()
    })
  }
}

enum QcStatusType {
  ACCEPTED = 'Accepted',
  PENDING = 'Pending',
  REJECTED = 'Rejected',
  AUTO_APPROVED = 'Auto_Approved',
  NEED_MORE_INFORMATION = 'Need_More_Information'
}
export const statusBadgeClassName = (status: any, isSalesadmin?: boolean) => {
  if (isSalesadmin) {
    switch (status) {
      case QcStatusType.ACCEPTED:
      case QcStatusType.AUTO_APPROVED:
        return 'badge badge-light-success';

      case QcStatusType.PENDING:
      case QcStatusType.NEED_MORE_INFORMATION:
        return 'badge badge-light-warning';

      case QcStatusType.REJECTED:
        return 'badge badge-light-danger';

      default:
        return 'badge badge-light-secondary';
    }
  }

  if (
    status === 'PASSED' ||
    status === 'ACCEPTED' ||
    status === 'ASSIGNED' ||
    status === 'AUTO_APPROVED' ||
    status === 'NO_TPV' ||
    status === 'approved'
  ) {
    return 'badge badge-light-success'
  } else if (
    status === 'PENDING' ||
    status === 'INCOMPLETE' ||
    status === 'UNVERIFIED' ||
    status === 'NEED_MORE_INFORMATION' ||
    status === 'pending'
  ) {
    return 'badge badge-light-warning'
  } else if (status === 'FAILED' || status === 'REJECTED' || status === 'UNASSIGNED') {
    return 'badge badge-light-danger'
  }
}

export const capitalizeFirstLetter = (string: string) => {
  return string?.charAt(0).toUpperCase() + string?.toLowerCase().slice(1)
}

export const convertStreamToURL = (data: any) => {
  const audioStream: any = data?.AudioStream
  const uInt8Array = new Uint8Array(audioStream)
  const arrayBuffer = uInt8Array.buffer
  const blob = new Blob([arrayBuffer], { type: 'audio/mp3' })
  return URL.createObjectURL(blob)
}

export function arrayMove<T>(array: readonly T[], from: number, to: number) {
  const slicedArray = array.slice()
  slicedArray.splice(to < 0 ? array.length + to : to, 0, slicedArray.splice(from, 1)[0])
  return slicedArray
}

export function generateUUID() {
  const tempValue: any = '10000000-1000-4000-8000-100000000000'
  return tempValue.replace(/[018]/g, (c: any) =>
    (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  )
}

export const chartOptions = (labels: any, colors: any) => {
  return {
    plotOptions: {
      pie: {
        donut: {
          size: '87%',
          labels: {
            show: true,
            value: {
              fontSize: '34',
              fontWeight: 700,
              color: '#5E6278',
            },
            total: {
              show: true,
              fontSize: '15',
              label: 'TPVs',
              fontWeight: 600,
              color: '#AAA5A5',
              marginBottom: '10',
            },
          },
        },
      },
      bar: {
        borderRadius: 10,
      },
    },
    labels,
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    grid: {
      padding: {
        right: 0,
        bottom: 12,
        left: 0,
      },
    },
    tooltip: {
      enabled: false,
    },
    stroke: {
      show: false,
      lineCap: 'round',
      width: '14',
    },
    colors,
    states: {
      hover: {
        filter: {
          type: 'none',
          value: 0.15,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
        },
      },
    },
  }
}

export const renderPhoneNumber = (number: string) => {
  return `+1(${number?.slice(0, 3)})${number?.slice(3, 6)}-${number?.slice(6, 10)}`
}

export const checkEmptyData = (data: string | number | null) => {
  return Boolean(String(data === null ? '' : data)) ? data : '-'
}

export const fetchGraphql = async (QUERY: any, variables: any) => {
  const TOKEN = await getToken()
  return fetch(`${process.env.REACT_APP_BACKEND_URL}`, {
    method: 'POST',
    headers: new Headers({
      Authorization: `Bearer ${TOKEN}`,
      'Content-Type': GLOBAL_CONSTANTS.apiContentTypejson,
    }),
    body: JSON.stringify({
      query: QUERY,
      variables: variables,
    }),
  }).then((res) => res.json())
}
export const httpLink = createHttpLink({
  uri: SERVER_URL,
})

export const authMiddleware = setContext(async (_, { headers }) => {
  // get the authentication token from aws-amplify
  const token = await getToken()

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
    },
  }
})

// logout onerror
export const logOut = onError(({ graphQLErrors }: any) => {
  console.log('Graphql Error', graphQLErrors)
  const getUserParams = window.location.pathname.split('/')
  // console.log("getUserParams", getUserParams[getUserParams.length - 1]);
  const getPath = localStorage.getItem('adminDashboardUrl')
    ? localStorage.getItem('adminDashboardUrl')
    : `/${getUserParams[1]}/login`
  if (graphQLErrors && graphQLErrors.length > 0) {
    graphQLErrors.forEach((error: any) => {
      console.log(error, error.extensions)
      if (error.code === 'UNAUTHENTICATED') {
        window.open(`${window.location.origin}/${getUserParams[1]}/login`, '_self')
        localStorage.removeItem('_accesstoken')
      } else if (error?.extensions?.exception?.message === 'User is Disabled') {
      } else if (error?.extensions?.exception?.message === 'Sales Channel is not Active') {
      } else if (
        error.extensions &&
        error.extensions?.exception?.name &&
        error.extensions?.exception?.name === 'UnauthenticatedException' &&
        error?.extensions?.exception.message !== 'User does not exist!' &&
        error?.extensions?.exception.message !== 'User account is not active.'
      ) {
        if (error.extensions?.exception?.message !== 'Client is not Active') {
          window.open(`${window.location.origin}/${getUserParams[1]}/login`, '_self')
          localStorage.removeItem('_accesstoken')
        } else if (
          error.extensions?.exception?.message === 'Client is not Active' &&
          getUserParams[getUserParams.length - 1] !== 'login'
        ) {
          window.open(`${window.location.origin}/${getUserParams[1]}/login`, '_self')
          localStorage.removeItem('_accesstoken')
        }
      }
      //else if (
      //   error.extensions &&
      //   error.extensions?.code &&
      //   error.extensions?.code === 'UNAUTHENTICATED'
      // ) {
      //   window.open(`${window.location.origin}${getPath}`, '_self')
      //   localStorage.removeItem('_accesstoken')
      // }
    })
  }
})

export const appoloClientConfig = new ApolloClient({
  link: from([authMiddleware, logOut, httpLink]),
  cache: new InMemoryCache(),
})

export const areYouSurePrompt = (
  title: string,
  successFn: () => void,
  deniedFn: () => void,
  successText?: string,
  failText?: string,
  text?: string,
  html?: string
) => {
  MySwal.fire({
    title,
    text,
    html,
    iconHtml: `<img src=${SwalThinkingImage}>`,
    customClass: {
      icon: 'no-border',
    },
    showCancelButton: true,
    showConfirmButton: !!successText,
    confirmButtonText: successText,
    confirmButtonColor: '#3E97FF',
    cancelButtonText: failText,
    cancelButtonColor: !!successText ? 'rgb(39 37 37 / 52%)' : '#3E97FF',
    reverseButtons: true,
  }).then((result) => {
    if (result.isConfirmed) {
      successFn()
    }
    if (result.isDismissed) {
      deniedFn()
    }
  })
}
const QUERY = `
query getSignedUrlForUpload($bucketName: String!, $key: String!) {
  getSignedUrlForUpload(bucketName: $bucketName, key: $key) {
    preSignedUrl
  }
}`
const options = {
  maxSizeMB: 1,
  maxWidthOrHeight: 1920,
  useWebWorker: true,
}
export const uploadFiles = async (
  files: any[],
  isMandatory?: boolean,
  imageFolderName?: string,
  pdfFolderName?: string
) => {
  return Promise.all(
    files.map(async (file: File, index: number) => {
      const TOKEN = await getToken()
      console.log('type===', file.type)
      if (file.type.includes('image') || file.type.includes('pdf')) {
        const folderName = file.type.includes('image') ? imageFolderName : pdfFolderName
        const contentType = file.type.includes('image') ? 'image/*' : 'application/pdf'
        return fetch(`${process.env.REACT_APP_BACKEND_URL}`, {
          method: 'POST',
          headers: new Headers({
            Authorization: `Bearer ${TOKEN}`,
            'Content-Type': GLOBAL_CONSTANTS.apiContentTypejson,
          }),
          body: JSON.stringify({
            query: QUERY,
            variables: {
              key: `${folderName}/${file.name
                .replace(/\s+/g, '-')
                .split('.')
                .join('-' + Date.now() + '.')}`,
              bucketName: process.env.REACT_APP_BUCKET_NAME,
            },
          }),
        })
          .then((res) => res.json())
          .then((jsonData) => jsonData.data.getSignedUrlForUpload.preSignedUrl)
          .then(async (url) => {
            let compressedFile = file
            if (file.type.includes('image')) {
              compressedFile = await imageCompression(file, options)
            }
            console.log(compressedFile.size)
            return await fetch(url, {
              method: 'PUT',
              headers: { 'Content-Type': contentType },
              body: compressedFile,
            }).then((response) => {
              if (response && response.url) {
                return response.url.split('com/')[1].split('?')[0]
              }
            })
          })
      }
    })
  )
    .then((values: any) => values)
    .catch((err) => console.log(err))
}

export const downloadFilesFromS3 = async (filePath: string, fileName: string) => {
  const response = await fetch(`${process.env.REACT_APP_IMAGE_BASE_URL}${filePath}`)
  const blob = await response.blob()
  fileDownload(blob, `${fileName}.pdf`)
}

export function isValidURL(url: any) {
  try {
    new URL(url)
    return true
  } catch (e) {
    return false
  }
}
